export const DEFAULT_OTHER_LABEL = 'Outra opção';
export const otherOptionLabel = field => String(field?.otherOptionLabel || '').trim() || DEFAULT_OTHER_LABEL;
export function normalizeOtherOption(value, field = {}) {
  let text = String(value ?? '').normalize('NFC');
  if (field.otherOptionAllowAccents === false) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  if (field.otherOptionInput === 'numbers') text = text.replace(/[^0-9]/g, '');
  if (field.otherOptionInput === 'letters') text = text.replace(/[^\p{L}\p{M}\s]/gu, '');
  if (field.otherOptionInput === 'alphanumeric') text = text.replace(/[^\p{L}\p{M}0-9\s]/gu, '');
  return field.otherOptionUppercase ? text.toLocaleUpperCase('pt-BR') : text;
}
